module.exports = {
      id: "image-usage",
      viewBox: "0 0 27 27",
      url: __webpack_public_path__ + "svg-sprite.svg#image",
      toString: function () {
        return this.url;
      }
    }